import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TravelAbroadState, setCurrency, setLimit } from '../../../store/travelAbroadSlice'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import RadioButton from '../../../components/v2/buttons/RadioButton'
import { AppState } from '../../../store/appSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { currencySymbol } from '../../../domain/types'
import { Helmet } from 'react-helmet-async'
//
//
const CurrencyAndLimit = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  // travel currencies
  const { data: travelCurrencies, isLoading: isTravelCurrenciesLoading } = api.useGetTravelCurrenciesQuery('usd-eur')
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  // get travel limits by currency
  const { data: travelLimitsByCurrency } = api.useGetTravelLimitsByCurrencyQuery(filter.currency as string, {
    skip: !filter.currency && true,
  })
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.singleOrMulti &&
      filter.region &&
      filter.currency &&
      ((filter.singleDates?.start && filter.singleDates?.end) ||
        (filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days))
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: filter.limit ? 'step-five' : 'step-four',
            productCategory: filter.productCategory,
            startDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.start as string)
                : (filter.multiDates?.start as string),
            endDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.end as string)
                : (filter.multiDates?.end as string),
            multiDay: filter.singleOrMulti === 'single-travel' ? null : (filter.multiDays?.days as number),
            travelType: filter.singleOrMulti,
            currency: filter.currency,
            limit: filter.limit as number,
            area: filter.region,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (CurrencyAndLimit)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleOrMulti,
    filter.multiDates?.start,
    filter.multiDates?.end,
    filter.multiDays?.days,
    filter.region,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    getLeftCompanies,
  ])
  //
  //
  return isTravelCurrenciesLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('travelLimitsFranchiseTitle')}</title>
        <meta name="description" content={`${t('travelLimitsFranchiseTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('travelLimitsFranchiseTitle')} />

        <AbroadProgressBar stepName={`${t('currencyLimit')}`} />

        <Block>
          <Cards>
            {travelCurrencies &&
              travelCurrencies?.map((item, index) => {
                return (
                  <HorizontalCard
                    className="horizontal-card"
                    key={index}
                    title={item?.translations?.[lang]?.title}
                    imgUrl={item?.image}
                    selected={item.type === filter.currency ? true : false}
                    onClick={() => {
                      if (item.type) {
                        dispatch(setCurrency(item.type))
                        //
                        if (filter.currency !== item.type) {
                          dispatch(setLimit(null))
                        }
                      }
                    }}
                  >
                    {item.type === filter.currency ? (
                      <LimitDiv>
                        <hr />
                        <LimitTitle>{travelCurrencies?.find((x) => x)?.translations?.[lang]?.secondTitle}</LimitTitle>
                        <LimitDescription>
                          {travelCurrencies?.find((x) => x)?.translations?.[lang]?.excerpt}
                        </LimitDescription>
                        <CheckboxBlock>
                          <RadioButton
                            size="small"
                            defaultOption={filter.limit}
                            onChange={(value) => {
                              dispatch(setLimit(Number(value)))
                            }}
                            options={
                              travelLimitsByCurrency
                                ? [
                                    ...travelLimitsByCurrency?.map((item) => ({
                                      value: item.value,
                                      label:
                                        item.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                                        ` ${currencySymbol(filter.currency)}`,
                                    })),
                                  ]
                                : []
                            }
                          />
                        </CheckboxBlock>
                      </LimitDiv>
                    ) : null}
                  </HorizontalCard>
                )
              })}
          </Cards>

          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
          />
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/select-region')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.singleOrMulti &&
              filter.currency &&
              filter.limit &&
              filter.region &&
              leftCompanies &&
              leftCompanies.length >= 1 &&
              ((filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days) ||
                (filter.singleDates?.start && filter.singleDates?.end))
                ? false
                : true
            }
            onClick={() => navigate('/add-travelers')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Block = styled.div`
  max-width: 464px;
  margin-inline: auto;
`
const CheckboxBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
`
const LimitTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 4px;
`
const LimitDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const LimitDiv = styled.div``

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  .horizontal-card-content {
    align-items: center;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default CurrencyAndLimit
